import { mode } from '@chakra-ui/theme-tools';

export const menuStyles = {
  components: {
    Menu: {
      baseStyle: (props) => ({
        button: {
          transition: '0.3s all',
          outline: 'unset',
          borderRadius: '10px',
          border: '1px solid rgba(255, 255, 255, 0.20)',
          position: 'relative',
          h: '44px',
          textAlign: 'center',
          'span > div': {
            position: 'relative',
            borderRadius: '9px',
            bg: mode(
              'linear-gradient(0deg, rgba(9, 155, 255, 0.17) 4.55%, rgba(255, 255, 255, 0.00) 100%), #EDF0FF',
              'linear-gradient(17deg, #29498F 12.16%, rgba(22, 43, 90, 0.30) 119.99%), #151A32')(props),
          },
          _hover: {
            'span > div': {
              bg: 'linear-gradient(16deg, rgba(22, 43, 90, 0.30) -13.5%, #29498F 85.98%), rgba(24, 112, 236, 0.05)'
            }
          },
          _active: {
            'span > div': {
              bg: 'linear-gradient(0deg, #29498F 0%, #29498F 100%), rgba(0, 78, 174, 0.10)'
            }
          }
        },
        list: {
          color: mode('gray.800', 'white')(props),
          p: '12px 0px',
          borderRadius: '10px',
          borderWidth: '1px', 
          borderColor: mode('rgba(0, 0, 0, 0.10)', '#2c354f')(props),
          bg:  mode('linear-gradient(0deg, rgba(9, 155, 255, 0.17) -34.69%, rgba(255, 255, 255, 0.00) 100%), #EDF0FF', 'linear-gradient(0deg, #29498F -34.69%, rgba(22, 43, 90, 0.30) 100%), #151A32')(props),
          boxShadow: mode('0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)', '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)')(props),
          '> button': {
            p: '9px 14px',
            my: '3px',
            fontSize: '14px', 
            fontStyle: 'normal' ,
            fontWeight: '400',
            color: mode('blue.900', 'white')(props), 
            _focus: {
                bg: '#10337F !important',
            },
            _active: {
                bg: '#10337F !important',
            },
            _hover: {
              bg: '#10337F !important'
            },
          },
          'div > button': {
            p: '9px 14px',
            my: '3px',
            fontSize: '14px', 
            fontStyle: 'normal' ,
            fontWeight: '400',
            color: mode('blue.900', 'white')(props), 
            _focus: {
                bg: '#10337F !important',
            },
            _active: {
                bg: '#10337F !important',
            },
            _hover: {
              bg: '#10337F !important'
            },
          },
        },
      }),
      variants: {
        wallet: (props) => ({
          button: {
            transition: '0.3s all',
            outline: 'unset',
            borderRadius: '10px',
            border: 'unset',
            position: 'relative',
            h: '44px',
            textAlign: 'center',
            'span > div': {
              position: 'relative',
              borderRadius: '10px',
              bg: mode(
                'linear-gradient(0deg, rgba(9, 155, 255, 0.17) 4.55%, rgba(255, 255, 255, 0.00) 100%), #EDF0FF',
                'linear-gradient(0deg, #29498F -69.32%, rgba(22, 43, 90, 0.30) 100%), #151A32')(props),
            },
            _hover: {
              borderRadius: '10px',
              'span > div': {
                bg: 'linear-gradient(16deg, rgba(22, 43, 90, 0.30) -13.5%, #29498F 85.98%), rgba(24, 112, 236, 0.05)'
              }
            },
            _active: {
              'span > div': {
                bg: 'linear-gradient(0deg, #29498F 0%, #29498F 100%), rgba(0, 78, 174, 0.10)'
              }
            }
          },
        }),
        profile: (props) => ({
          button: {
            transition: '0.3s all',
            outline: 'unset',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.20)',
            position: 'relative',
            h: '44px',
            textAlign: 'center',
            'span > div': {
              position: 'relative',
              borderRadius: '9px',
              bg: mode(
                'linear-gradient(0deg, rgba(9, 155, 255, 0.17) 4.55%, rgba(255, 255, 255, 0.00) 100%), #EDF0FF',
                'linear-gradient(0deg, #29498F -69.32%, rgba(22, 43, 90, 0.30) 100%), #151A32')(props),
            },
            _hover: {
              'span > div': {
                bg: 'linear-gradient(16deg, rgba(22, 43, 90, 0.30) -13.5%, #29498F 85.98%), rgba(24, 112, 236, 0.05)'
              }
            },
            _active: {
              'span > div': {
                bg: 'linear-gradient(0deg, #29498F 0%, #29498F 100%), rgba(0, 78, 174, 0.10)'
              }
            }
          },
        }),
        filter: (props) => ({
          button: {
            transition: '0.3s all',
            outline: 'unset',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.20)',
            position: 'relative',
            h: '44px',
            textAlign: 'center',
            'span > div': {
              position: 'relative',
              borderRadius: '9px',
              bg: mode(
                'linear-gradient(0deg, rgba(9, 155, 255, 0.17) 4.55%, rgba(255, 255, 255, 0.00) 100%), #EDF0FF',
                'linear-gradient(17deg, #29498F 12.16%, rgba(22, 43, 90, 0.30) 119.99%), #151A32')(props),
            },
            _hover: {
              'span > div': {
                bg: 'linear-gradient(16deg, rgba(22, 43, 90, 0.30) -13.5%, #29498F 85.98%), rgba(24, 112, 236, 0.05)'
              }
            },
            _active: {
              borderColor: 'rgba(255, 255, 255, 0.10)',
              'span > div': {
                bg: '#0279CB',
                'svg > path': {
                  fill: 'white'
                }
              }
            }
          },
        }),
        ghost: (props) => ({
          button: {
            transition: '0.3s all',
            border: 'unset',
            outline: 'unset',
            'span > div': {
              bg: 'unset',
              'p': {
                transition: '0.3s all',
                color: mode('blue.800', '#9FABCB')(props),
                fontWeight: '600',
                fontSize: '16px'
              },
              'svg': {
                mt: '0px',
                ml: '6px',
                'path': {
                  transition: '0.3s all',
                  stroke:  mode('blue.800', '#9FABCB')(props), 
                }
              }
            },
            _hover: {
              border: 'unset',
              'span > div': {
                bg: 'unset',
                'p': {
                  color: '#099BFF',
                },
                'svg': {
                  'path': {
                    stroke:  mode('blue.800', '#099BFF')(props), 
                  }
                }
              }
            },
            _active: {
              border: 'unset',
              'span > div': {
                bg: 'unset',
                'p': {
                  color: '#099BFF',
                },
                'svg': {
                  'path': {
                    stroke:  mode('blue.800', '#099BFF')(props), 
                  }
                }
              }
            }
          }
        }),
      },
    },
  },
};
